export default {
  isOverviewChartShown: 'Show overview chart',
  isZoomedChartShown: 'Show chart zoomed to tolerance band',
  isSectionsTableShown: 'Show sections table',
};
